// Generated by CoffeeScript 2.3.2
module.exports = '1.4.5';
